<template>
<div class="chapter">
<div class="inner_page">
<p style="text-align:center;">OTHER BOOKS IN<br/> THE AMERICAN ANTIQUARIAN SOCIETY<br/> COOKBOOK COLLECTION</p>
<hr/>
<p class="center8"><em>American Cookery</em>, by Amelia Simmons</p>
<p class="center8"><em>The Canadian Housewife’s Manual of Cookery</em></p>
<p class="center8"><em>The Compleat Housewife</em>, by Eliza Smith</p>
<p class="center8"><em>The Cook Not Mad</em></p>
<p class="center8"><em>Cottage Economy, </em>by William Cobbett</p>
<p class="center8"><em>Dainty Dishes</em>, by Lady Harriet E. St. Clair</p>
<p class="center8"><em>Dairying Exemplified</em>, by Josiah Twamley</p>
<p class="center8"><em>Fifteen Cent Dinners for Families of Six</em>, by Juliet Corson</p>
<p class="center8"><em>The Hand-Book of Carving</em></p>
<p class="center8"><em>How to Mix Drinks, </em>by Jerry Thomas</p>
<p class="center8"><em>Jewish Cookery Book</em>, by Esther Levy</p>
<p class="center8"><em>Miss Leslie's New Cookery Book, </em>by Eliza Leslie</p>
<p class="center8"><em>Mrs. Owen's illinois Cook Book, </em>by Mrs. T.J.V. Owen</p>
<p class="center8"><em>Mrs. Porter's New Southern Cookery Book</em>, by Mrs. M.E. Porter</p>
<p class="center8"><em>The New England Cook Book  </em></p>
<p class="center8"><em>The Physiology of Taste</em>, by Jean A. Brillat-Savarin</p>
<p class="center8"><em>A Treatise on Bread</em>, by Sylvester Graham</p>
<p class="center8"><em>Vegetable Diet</em>, by William Alcott</p>
<p class="center8"><em>What to Do with the Cold Mutton</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// other.vue?f32c2a4a